export default [
  {
    header: 'Задачи авторов',
    resource: 'author-tasks',
    action: 'view',
  },
  {
    title: 'Задачи авторов',
    route: 'author-tasks',
    icon: 'PenToolIcon',
    resource: 'author-tasks',
    action: 'view',
  },
]
